import interceptors from '@/api/supplier/interceptorsSupplier';
import { clientSupplier } from '@/api/supplier/client';
import qs from "qs";

clientSupplier.interceptors.request.use(interceptors.auth, interceptors.onError);

function getPDO(params) {
	return clientSupplier.get("api-supplier/pdo/data", {
		params: params,
	});
}

function exportPDO(params) {
	return clientSupplier.get("api-supplier/pdo/export", {
		params: params,
	});
}

function getStatusPDO() {
	return clientSupplier.get("api-supplier/options/pdo_status");
}

function getDetailPDO(params) {
	return clientSupplier.get("api-supplier/pdo/detail", {
		params: {
			pdo_code: params
		},
	});
}

function getSchedule(params) {
	return clientSupplier.get("api-supplier/pdo/schedule_by_code", {
		params: {
			po_code: params
		},
	});
}

function getScheduleByDate(params) {
	return clientSupplier.get("api-supplier/pdo/schedule_by_date", {
		params: {
			po_code: params.po_code,
			po_schedule_detail_date: params.po_schedule_detail_date
		},
	});
}

function createPDO (params) {
	return clientSupplier.post("api-supplier/pdo/create", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deliveryPDO (params) {
	return clientSupplier.post("api-supplier/pdo/delivery", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getPDO,
	exportPDO,
	getDetailPDO,
	createPDO,
	deliveryPDO,
	getStatusPDO,
	getSchedule,
	getScheduleByDate
};